/* Main scripts of theme */

/**
 * [SITE description]
 * @type {Object}
 */
var SITE = {

	/**
     * Global settings.
     */
    Settings: {
        property: 'marketingschool'
    },
    isPage: function(page){
    	return $('body').hasClass(page);
    },
    init: function() {
        "use strict";

        // Testimonials slider
		if($('.testimonials .slider').length > 0) {

			$('.testimonials .slider').slick({
				infinite: true,
				slidesToShow: 2,
				slidesToScroll: 2,
				arrows: false,
				dots: true,
				responsive: [
					{
						breakpoint: 1024,
						settings: {
							slidesToShow: 1,
							slidesToScroll: 1
						}
					}
				]
			});

		}

		SITE.UI.init();
        SITE.Marketing.init();
    }
};

jQuery(document).ready(function() { SITE.init(); });

/* End of file main.js */